import { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Button, Chip, Grid, IconButton, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import ProductCard from 'src/components/card/ProductCard';
import FillterCabinet from 'src/components/fillter/Fillter';
import ProductFilterSidebar from 'src/components/fillter/ProductFilterSidebar';
import Loader from 'src/components/loader/loader';
import ChooseCabinetModal from 'src/components/modal/ChooseCabinetModal';
import { UserListToolbar } from 'src/sections/@dashboard/user';
import { eventList, glb_sv, sendRequest, serviceList } from 'src/utils';
import crypt from 'src/utils/service/crypt';
import Iconify from 'src/components/iconify';
import EmtyData from 'src/components/emty-data';

// Memoized grid for faster render
const DeviceGrid = ({ products, handleAddProduct }) => {
    if (!products?.length) return <EmtyData />;
    return (
        <Grid container spacing={3}>
            {products.map((product, index) => (
                <Grid key={index} item xs={6} sm={4} md={3} xl={2.4}>
                    <ProductCard
                        sizeButtonAdd={'small'}
                        isHaveNote={false}
                        product={product}
                        functOnClick={handleAddProduct}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

export default function ListDeviceToAdd({
    idGroup,
    setData,
    handleAddProduct,
    activeTab,
    dataDrawer,
    setDataDrawer,
    valueCabinet,
    setValueCabinet,
    arrProperties,
    setArrProperties,
    valueDrawer,
    setValueDrawer,
    cabinetRef,
    user,
    visibleCabinet,
    setVisibleCabinet,
    dataCabinet,
}) {
    const [getFlags, setGetFlags] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [openFilter, setOpenFilter] = useState(false);
    const arrFillters = useRef([]);
    const getDeviceFlags = useRef(false);
    const { t } = useTranslation();

    useEffect(() => {
        if (!cabinetRef.current?.id) return;
        getData(cabinetRef.current.id, valueDrawer?.id || null);
    }, [valueDrawer, arrProperties]);

    // -------------------------
    // 4. Fetch devices
    // -------------------------
    const getData = useCallback(
        (cabId, drawId) => {
            if (getDeviceFlags.current) return;
            getDeviceFlags.current = true;
            setGetFlags(true);

            const filters = arrProperties
                .map((item) => ({
                    label: item.label,
                    value: item.value.filter((sub) => sub.checked).map((sub) => sub.value),
                }))
                .filter((f) => f.value.length > 0);

            let InVal;
            if (!drawId) {
                InVal = [cabId, user.current.depart_cd, filters, +idGroup];
                sendRequest(
                    activeTab == 0 ? serviceList.getAllDeviceTakeCabinet : serviceList.getAllDeviceCabinet,
                    InVal,
                    getDataResult,
                    true,
                    timeOutFunct,
                    15000
                );
            } else {
                InVal = [cabId, drawId, user.current.depart_cd, filters, +idGroup];
                sendRequest(
                    activeTab == 0 ? serviceList.getAllDeviceTakeDrawer : serviceList.getAllDeviceBorrowDraw,
                    InVal,
                    getDataResult,
                    true,
                    timeOutFunct,
                    15000
                );
            }
        },
        [arrProperties]
    );

    const getDataResult = (reqInfo, message) => {
        getDeviceFlags.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        }
        console.log(message);
        setTableData(message.proc_data.rows[0].o_1);
        arrFillters.current = message.proc_data.rows[0].o_1;
    };

    const timeOutFunct = () => {
        getDeviceFlags.current = false;
        setGetFlags(false);
        toast.error(t('error.time_out'));
    };

    // -------------------------
    // 5. Filter search
    // -------------------------
    const fillterSearcher = (value) => {
        if (!value) return setTableData(arrFillters.current);
        setTableData(
            arrFillters.current.filter(
                (d) => d.device_nm.includes(value.toUpperCase()) || d.device_cd.includes(value.toUpperCase())
            )
        );
    };

    // -------------------------
    // 6. Handle delete chip
    // -------------------------
    const handleDelete = (item, index, indexParent) => {
        if (!item) return;
        arrProperties[indexParent].value[index].checked = !arrProperties[indexParent].value[index].checked;
        setArrProperties([...arrProperties]);
    };

    // -------------------------
    // 7. Go back
    // -------------------------
    const goBack = () => setData(null);

    // -------------------------
    // 8. Render
    // -------------------------
    return (
        <>
            <Helmet>
                <title>{activeTab == 0 ? t('getting_device') : t('rorrowing_device')}</title>
            </Helmet>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <IconButton onClick={goBack}>
                    <Iconify icon="ic:baseline-arrow-back-ios" />
                </IconButton>

                <Typography variant="h4">{activeTab == 0 ? t('getting_device') : t('rorrowing_device')}</Typography>
            </Box>
            <ChooseCabinetModal visible={visibleCabinet} setVisible={setVisibleCabinet} />
            <Grid container spacing={3} alignItems={'center'}>
                <Grid item xs={12} sm={12} md={6} xl={8}>
                    <UserListToolbar getValue={fillterSearcher} />
                </Grid>
                <Grid item xs={12} sm={12} md={6} xl={4}>
                    <Stack
                        direction="row"
                        alignItems="center"
                        width={'100%'}
                        justifyContent="flex-end"
                        flexWrap={'wrap'}
                        gap={1}
                        sx={{ mb: 1 }}
                    >
                        <ProductFilterSidebar
                            valueChange={arrProperties}
                            openFilter={openFilter}
                            getValue={setArrProperties}
                            onCloseFilter={() => setOpenFilter(false)}
                            onOpenFilter={() => setOpenFilter(true)}
                            idGroup={idGroup}
                        />
                        {glb_sv.userInfo.group_user !== '3' && (
                            <FillterCabinet
                                setValueSort={(data) => {
                                    setValueCabinet(data);
                                    setValueDrawer({ drawer_nm: t('all'), id: null });
                                }}
                                arrSort={dataCabinet}
                                labelDisplay="cabinet_nm"
                                defaultValue={dataCabinet.length > 0 ? dataCabinet[0].cabinet_nm : ''}
                                title={t('cabinet')}
                            />
                        )}
                        <FillterCabinet
                            setValueSort={setValueDrawer}
                            labelDisplay="drawer_nm"
                            arrSort={dataDrawer}
                            valueSort={valueDrawer ? valueDrawer : null}
                            defaultValue={dataDrawer.length > 0 ? dataDrawer[0].drawer_nm : ''}
                            title={t('drawer')}
                        />
                    </Stack>
                </Grid>
                <Stack direction="row" flexWrap={'wrap'} padding={2} spacing={1}>
                    {arrProperties.length > 0 &&
                        arrProperties.map((item, index) => {
                            return (
                                <div key={index} style={{ gap: 1 }}>
                                    {item?.value?.length > 0 &&
                                        item.value.map((value, idx) => {
                                            if (value.checked) {
                                                return (
                                                    <Chip
                                                        variant="outlined"
                                                        key={idx}
                                                        sx={{ marginLeft: 1 }}
                                                        label={glb_sv.convertMultipleLanguages(value?.label)}
                                                        color="primary"
                                                        // onClick={() => handleClick(item, index)}
                                                        onDelete={() => handleDelete(item, idx, index)}
                                                    />
                                                );
                                            }
                                        })}
                                </div>
                            );
                        })}
                </Stack>
            </Grid>
            <Loader loading={getFlags} />
            <DeviceGrid products={tableData} handleAddProduct={handleAddProduct} />
        </>
    );
}
